import * as React from "react";
import { Check } from "lucide-react";
const fields = [{
  name: "Signal word & header",
  description: "an ANSI Z535 signal word such as WARNING or DANGER, selected per the hazard."
}, {
  name: "Nominal system voltage",
  description: "the equipment's working voltage."
}, {
  name: "Arc flash boundary",
  description: "the approach distance from the study."
}, {
  name: "Incident energy & working distance",
  description: "incident energy (cal/cm²) at the stated working distance, OR an arc flash PPE category, as the study reports."
}, {
  name: "Required PPE",
  description: "the protection level the study specifies for the task."
}, {
  name: "Shock hazard data",
  description: "limited/restricted approach boundaries and voltage, when specified."
}, {
  name: "Equipment ID",
  description: "the panel, switchboard, or MCC identifier."
}, {
  name: "Analysis date",
  description: "the date of the arc flash study, supporting the review cycle."
}];
export default function WhatInformationGoesOnAnArcFlashLabel() {
  return <section id="what-information-goes-on-an-arc-flash-label" className="bg-muted py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="mb-10">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-card-foreground mb-6">
            What Information Goes on an Arc Flash Label?
          </h2>
          <p className="text-lg text-foreground leading-relaxed">
            An arc flash label carries the hazard data for one specific piece of equipment. Evermark Industrial Solutions produces labels with the fields a project specifies, commonly including:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12">
          {fields.map((field, i) => <div key={i} data-index={i} className="flex items-start gap-3 bg-background p-5 rounded-lg border border-border shadow-sm">
              <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
              <p className="text-sm md:text-base leading-relaxed">
                <strong className="text-card-foreground font-default font-semibold">{field.name}</strong> 
                <span className="text-muted-foreground"> — {field.description}</span>
              </p>
            </div>)}
        </div>

        <div className="bg-background/60 border-l-4 border-primary p-6 rounded-r-lg shadow-sm">
          <p className="text-base text-foreground leading-relaxed">
            Every value above originates in the customer's arc flash study. Evermark Industrial Solutions reproduces the supplied data exactly as specified and confirms the layout on a proof before production — Evermark does not alter, calculate, or validate the hazard values.
          </p>
        </div>
      </div>
    </section>;
}